  var slideIndex = 1;

jQuery(document).ready(function($) {
  if ($('.slide_content').length)
    showSlides(1);

  $('.slide_nav__next').click(function(){
    showSlides(slideIndex += 1);
  });
  $('.slide_nav__prev').click(function(){
    showSlides(slideIndex -= 1);
  });

  function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("slide_content__image--right");
  var slides2 = document.getElementsByClassName("slide_content__image--left");

  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}

  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
      slides2[i].style.display = "none";
  }

  if (slides.length > 0)
    $('.slide_nav').css("display", "block");
  else
    $('.slide_nav').css("display", "none");

  slides[slideIndex-1].style.display = "block";
  slides2[slideIndex-1].style.display = "block";

  $('.slide_nav__current-slide').text(slideIndex);
  $('.slide_nav__total-slides').text(slides.length);
}
}(jQuery));
